import { Box, Stack, Typography } from '@mui/material'
import { GRAY_700, GRAY_900 } from 'constants/styling/theme'

import { EmbedSessionProvider } from 'utils/embedSession/embedSession'
import { FC } from 'react'
import Logo from 'components/common/Logo/Logo'
import propstackLogo from 'assets/img/integrations/propstack_logo.svg'
import { useEmbedCrm } from 'utils/embedSession/useEmbedCrm'
import { useTranslation } from 'react-i18next'

/** CRM marks shown beside the name; a CRM without one shows its name alone. */
const CRM_LOGOS: Partial<Record<EmbedSessionProvider, string>> = {
  propstack: propstackLogo,
}

/**
 * @component
 * BACKBONE × CRM co-branding shown on the left of the embed purchase-flow footer, per the
 * prototype (ISSUE-3100). Carrying the branding inside the iframe lets Propstack drop their own
 * branding pill under the iframe — the extra element that forced their modal to scroll.
 *
 * @example <EmbedCoBranding />
 */
export const EmbedCoBranding: FC = () => {
  const { t } = useTranslation(['embed'])
  const { provider, crmName } = useEmbedCrm()
  const crmLogo = CRM_LOGOS[provider]

  return (
    <Stack
      gap={1.2}
      direction="row"
      alignItems="center"
      flexShrink={0}
      data-testid="embed-co-branding"
      aria-label={t('value_proposition.branding_crm', { crm: crmName })}
    >

      <Logo width="9.4rem" display="flex" />

      <Typography variant="text-sm" color={GRAY_700}>×</Typography>

      <Stack gap={0.6} direction="row" alignItems="center">
        {crmLogo && <Box component="img" src={crmLogo} alt="" width="2rem" height="2rem" />}
        <Typography variant="text-md" fontWeight={600} color={GRAY_900}>{crmName}</Typography>
      </Stack>

    </Stack>
  )
}
